





















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateSignature,
  getSignatureStatus,
  getSignatureList,
  getSignatureArea,
  setSignature,
  deleteUdid,
  changeAccount
} from '@/api/developer/developer-private/private'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  formatTime,
  deepCopy,
  confirmMiddleWare
} from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'DeveloperPirvateSignature'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    id: '',
    name: '',
    udid: '',
    account: '',
    failInfo: '',
    serverCode: '',
    status: '',
    signArea: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  // component data
  tableLoading = false
  tableHeight: number = 500
  loadingText = ''
  private statusMap: Map<String, String> = new Map([['签署成功', 'six'], ['签署失败', 'seven'], ['签署中', 'five']])
  private tableData: any[] = []
  private statusList: any[] = []
  private areaList: any[] = []
  private selectedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private config: any = {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }
  private confirmMiddleWare: Function = confirmMiddleWare
  // lifecycle
  async created() {
    this.getTableData()
    this.getSignatureStatus()
    this.getAreaList()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    const mock: any[] = [{
      id: 1424322
    }]
    try {
      this.tableLoading = true
      let res: any = await getSignatureList(this.params)
      this.tableData = res.data.dataList || []
      this.totalCount = res.data.pageInfo.totalCount
      // this.tableData = mock
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  async getSignatureStatus() {
    let res: any = await getSignatureStatus()
    this.statusList = res.data.dataList
  }
  async handleExcel() {
    let excelParams = deepCopy(this.params)
    this.loadingText = '正在拼命加载...'
    this.tableLoading = true
    try {
      let res: any = await getSignatureList(
        Object.assign(excelParams, {
          page: 1,
          pageCount: 100000
        })
      )
      if (res.status.code === 0) {
        setTimeout(() => {
          this['$message'].success('导出成功!')
        }, 200)
      } else {
        this['$message'].error('导出失败!')
        return
      }
      const filterVal: string[] = [
        'appId',
        'appName',
        'udid',
        'accountId',
        'status',
        'serverArea',
        'serverCode',
        'filePath',
        'failInfo',
        'createDate',
        'updateDate',
        'signTime',
        'signInitTime',
        'totalTime'
      ]
      const theader: string[] = [
        '应用ID',
        '应用名称',
        '设备号',
        '开发者账号',
        '状态',
        '签名地区',
        '服务器',
        'IPA文件',
        '失败信息',
        '创建时间',
        '完成时间',
        '签名命令耗时',
        '设备账号绑定耗时',
        '签名总耗时'
      ]
      const list = res.data.dataList
      const data = formatJson(filterVal, list)
      exportJson2Excel(theader, data)
    } catch (error) {
      this['$message'].error(error as string)
    } finally {
      this.tableLoading = false
      this.loadingText = ''
    }
  }
  async getAreaList() {
    let res: any = await getSignatureArea()
    this.areaList = res.data.dataList
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  async handleDeleteUdid(item: IPrivateSignature) {
    const { serverArea: area, udid } = item
    let res: any = await deleteUdid({
      clearParam: [{ area, udid }]
    })
    if (res.status.code === 0) {
      this['$message'].success('清除成功')
    } else {
      this['$message'].error('清除失败')
    }
  }
  async handleChangeUdid(item: any) {
    const { id } = item
    let res: any = await changeAccount({ id })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
    }
  }
  async handleDeleteUdidAll() {
    let arr: Array<{ area: string; udid: string }> = []
    this.selectedData.forEach(item => {
      arr.push({
        area: item.serverArea,
        udid: item.udid
      })
    })
    let res: any = await deleteUdid({ clearParam: arr })
    if (res.status.code === 0) {
      this['$message'].success('清除成功')
    } else {
      this['$message'].error('清除失败')
    }
  }
  crypt(str: string) {
    return str.substring(0, 3) + '●●●●' + str.substring(str.length - 3, str.length)
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
